<template>
    <div class="glass-theme fade-in-page">
        <b-card :style="{'max-width': '2000px', 'width': 'auto', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}" class="glass-card">
            <!-- API Loading Overlay with Animation -->
            <transition name="loading-overlay">
                <div v-if="apiLoading" class="loading-overlay">
                    <div class="loading-card">
                        <div class="loading-animation">
                            <div class="loading-ring">
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="loading-logo">
                                    <i class="fas fa-search"></i>
                                </div>
                            </div>
                        </div>
                        <div class="loading-text">
                            <h3>{{ loadingMessage }}</h3>
                            <div class="loading-dots">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </div>
                        </div>
                        <div class="loading-progress">
                            <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                        </div>
                        <div class="loading-tips">
                            <p class="tip-text">{{ currentTip }}</p>
                        </div>
                    </div>
                </div>
            </transition>

            <b-card-text>
                <h4>ORDER TRACKER</h4>
                <b-alert variant="secondary" show class="glass-alert"><sub>This tool helps to track status and all the activity which has happened so far with the items for a given order. Enter the invoice # and see all the activity.</sub></b-alert>
            </b-card-text>

            <b-card-text>
                <b-form @submit="get_invoice_activity">
                    <div style="display: inline-block;">
                        <div>ENTER INVOICE #:</div>
                        <b-form-input v-model="invoice_id" class="glass-input"></b-form-input>
                    </div>

                    <div style="display: inline-block;">
                        <b-button type="submit" @click="get_invoice_activity" class="glass-btn">SUBMIT</b-button>
                    </div>
                </b-form>
            </b-card-text>

            <div>
                <!-- <loading :active="items_being_loaded"
                    :can-cancel="false"
                    :is-full-page="true">
                </loading> -->

                <div v-if="items.length > 0">
                    <b-card v-for="(item, idx) in items" :key="idx" style="overflow-x: scroll;" class="glass-card-inner fade-in-row" :style="{ animationDelay: `${idx * 0.1}s` }">
                        <h6>{{ item.product_name }} ({{item.product_sku }}) X {{item.quantity}}</h6>
                        <table class="text-monospace" style="width: 100%; overflow-x: scroll;">
                            <thead>
                                <tr style="background: linear-gradient(135deg, #1e293b, #0f172a); color: white;">
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        VENDOR
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        CATEGORY
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        QTY
                                    </th>
                                    <th style="min-width: 150px;" class="ipt_tdhr">
                                        SOLD AT
                                    </th>
                                    <th style="min-width: 100px;" class="ipt_tdhr">
                                        SOLD BY
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        ORDER TYPE
                                    </th>
                                    <th style="min-width: 100px;" class="ipt_tdhr">
                                        DLVRY DATE
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        MERCH STATUS
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        STATE
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        PICKUP TRK
                                    </th>
                                    <th style="min-width: 150px;" class="ipt_tdhr">
                                        PICKUP LOC
                                    </th>
                                    <th style="min-width: 150px;" class="ipt_tdhr">
                                        STAGING LOC
                                    </th>
                                    <th style="min-width: 150px;" class="ipt_tdhr">
                                        DROP LOC
                                    </th>
                                    <th style="min-width: 50px;" class="ipt_tdhr">
                                        DELIVERY TRUCK
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr class="fade-in-row" :style="{ animationDelay: `0.05s` }">
                                    <td class="ipt_tdr">
                                        {{ item.vendor }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.category }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.quantity }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.locsubsdict[item.location_id + '|' + item.sublocation_id]}}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.username }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.order_type }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ merchandise_statuses_dict[item.merchandise_status] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ states_dict[item.state] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.trucksdict[item.pickup_truck] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.locsubsdict[item.locsub] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.locsubsdict[item.ship_locsub] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.locsubsdict[item.drop_locsub] }}
                                    </td>
                                    <td class="ipt_tdr">
                                        {{ packet.trucksdict[item.truck] }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="item.states.length > 0">
                            <b-alert show v-for="(sitem, sidx) in item.states" v-bind:key="sidx" style="padding: 3px; margin: 4px; font-size: 14px;" :variant="((sitem.type == 'action') ? 'success' : 'warning')" class="glass-alert-small fade-in-row" :style="{ animationDelay: `${sidx * 0.05}s` }">
                                <div v-if="sitem.type == 'action'">
                                    ({{ sitem.ts }}) -> {{ (sitem.username || '').toUpperCase() }} CHANGED STATE TO <b>{{ states_dict[sitem.event] }}</b>
                                </div>
                                <div v-else>
                                    ({{ sitem.ts }}) -> {{ (sitem.username || '').toUpperCase() }}: {{ (sitem.event || '').toUpperCase() }}
                                </div>
                            </b-alert>
                        </div>
                        <div v-else>
                            <b-alert show variant="info" class="glass-alert-small">NO ACTIVITY.</b-alert>
                        </div>
                    </b-card>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import moment from "moment"
    import global_vars from "@/utilities/global_vars"
    import Backer from "@/components/globals/Backer"
    import Requestor from "@/utilities/Requestor"
    import mappings from '@/utilities/mappings'

    export default {
        name: "AdminToolsTrackInvoice",
        components: {Backer, flatPickr, Loading},
        data: function() {
            return {
                packet: {},
                sort_asc: true,
                items: [],
                items_being_loaded: false,
                invoice_id: null,
                states_dict: mappings.states_dict,
                merchandise_statuses_dict: mappings.merchandise_statuses_dict,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Tracking Order',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "🔍 Searching for order...",
                    "📋 Fetching order details...",
                    "📊 Analyzing activity log...",
                    "🔄 Processing status updates...",
                    "✨ Preparing timeline...",
                    "📝 Organizing order history..."
                ]
            }
        },
        computed: {
            currentTip() {
                return this.tips[this.currentTipIndex] || this.tips[0];
            }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = 'Tracking Order') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Tracking Order') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Tracking Order', 'Fetching Data', 'Processing Activity', 'Analyzing Status', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },
            
            get_invoice_activity: function(e){
                if (e){
                    e.preventDefault();
                }

                if (!this.invoice_id || this.invoice_id.trim() === '') {
                    this.$bvToast.toast(
                        "Please enter an invoice number.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.startApiLoading('Fetching Order Details');
                let that = this;
                let path = "/api/sales/get_invoice_activity/"
                let data = {invoice_id: (this.invoice_id || '').replace(/\s/g, '')}

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.items = [];
                    }
                    else {
                        that.items = response.data.result;
                        if (that.items.length === 0) {
                            that.$bvToast.toast(
                                "No order found with that invoice number.",
                                {title: "Info", autoHideDelay: 1500, variant:"info"}
                            );
                        }
                    }
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                let f =  function(error){
                    console.error(error);
                    that.$bvToast.toast(
                        "Error loading invoice activity. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }
                this.items_being_loaded = true;
                this.items = [];
                Requestor.getSync(path, data, s, f);
            },
            sortby: function(key){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items, key)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
        },
        beforeDestroy() {
            this.stopLoadingAnimation();
        }
    }
</script>

<style scoped>
    /* Glass Theme Background */
    .glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
    }

    .glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Page Entrance Animation */
    @keyframes fadeInPage {
        from {
            opacity: 0;
            transform: translateY(24px);
            filter: blur(2px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
            filter: blur(0);
        }
    }

    .fade-in-page {
        animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
    }

    /* Row Fade Animation */
    @keyframes fadeInRow {
        from {
            opacity: 0;
            transform: translateX(-8px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    .fade-in-row {
        opacity: 0;
        animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
    }

    /* Glass Card */
    .glass-card {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    .glass-card-inner {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 16px !important;
        margin-bottom: 15px;
    }

    /* Glass Alert */
    .glass-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 12px !important;
    }

    .glass-alert-small {
        background: rgba(255, 255, 255, 0.7) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 10px !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
        color: white !important;
        border: 1px solid rgba(255, 255, 255, 0.2) !important;
        transition: all 0.2s ease !important;
        border-radius: 10px !important;
        margin-left: 10px;
        padding: 8px 20px;
    }

    .glass-btn:hover:not(:disabled) {
        background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
        transform: translateY(-1px) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
    }

    /* Glass Input */
    .glass-input {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 1px solid rgba(128, 128, 128, 0.3) !important;
        border-radius: 10px !important;
        width: 250px;
    }

    .glass-input:focus {
        border-color: rgba(54, 64, 80, 0.5) !important;
        box-shadow: 0 0 0 2px rgba(54, 64, 80, 0.1) !important;
    }

    /* Loading Overlay Styles */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Original Styles */
    .non-header {
        font-weight: normal;
        font-size: 12px;
    }

    .ipt_tdhr {
        font-weight: normal;
        font-size: 13px;
        background: rgba(192, 192, 192, 0.3);
        padding: 8px;
        border-radius: 4px;
    }
    
    .ipt_tdr {
        font-weight: normal;
        font-size: 13px;
        background: rgba(240, 248, 255, 0.6);
        padding: 6px;
        border-radius: 4px;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .glass-input {
            width: 100%;
            margin-bottom: 10px;
        }
        
        .glass-btn {
            width: 100%;
            margin-left: 0;
        }
        
        .loading-card {
            padding: 32px 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsTrackInvoice.vue